import { useApolloClient } from '@apollo/client';

import type { DailyGoals_QueryDailyGoalsQuery as QueryDailyGoals } from 'bundles/daily-goals/__queries__/__generated__/queryDailyGoals';
import queryDailyGoals from 'bundles/daily-goals/__queries__/queryDailyGoals.graphql';
import type { DailyGoal } from 'bundles/daily-goals/types';

export const transformCacheDataToMarkGoalComplete = (data: QueryDailyGoals | null, goalId: string) => {
  if (!data?.DailyGoals?.queryDailyGoals?.dailyGoals) {
    return data;
  }

  return {
    ...data,
    DailyGoals: {
      ...data.DailyGoals,
      queryDailyGoals: {
        ...data.DailyGoals.queryDailyGoals,
        dailyGoals: data.DailyGoals.queryDailyGoals.dailyGoals.map((goal: DailyGoal) =>
          goal.goalId === goalId ? { ...goal, progressStatus: 'COMPLETED' as const } : goal
        ),
      },
    },
  };
};

export const useUpdateDailyGoalsApolloCache = () => {
  const client = useApolloClient();

  const markGoalComplete = (activeCourseId: string, goalId: string) => {
    client.cache.updateQuery<QueryDailyGoals>(
      {
        query: queryDailyGoals,
        variables: { activeCourseId },
      },
      (data) => transformCacheDataToMarkGoalComplete(data, goalId)
    );
  };

  return { markGoalComplete };
};
